import Button from "../../../../../common/components/button";
import SelectBox from "../../../../components/common/selectBox";
import Input from "../../../../components/common/input";
import NewGoods from "./NewGoods";
import GoodsTable from "./GoodsTable";
import React, { useEffect, useState } from "react";
import SettingHeader from "../SettingHeader";
import { useGetGoods } from "../../../../../common/hooks/console/management/goods/useGetGoods";
import ModifyGoods from "./ModifyGoods";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/closeIcon.svg";
import { ReactComponent as CloseWhiteIcon } from "../../../../assets/icons/closeWhiteIcon.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plusIcon.svg";
import { ReactComponent as Empty } from "../../../../../common/assets/icons/empty.svg";
import useToastStore from "../../../../store/useToastStore";
import { useDeleteGoods } from "../../../../../common/hooks/console/management/goods/useDeleteGoods";
import { useSystemPopStore } from "../../../../store/useSystemPopStore";
import { usePutGoodsCategory } from "../../../../../common/hooks/console/management/goods/usePutGoodsCategory";
import { useGetGoodsCategory } from "../../../../../common/hooks/console/management/goods/useGetGoodsCategory";
import CheckBox from "../../../../components/common/checkBox";
import { usePostGoodsCategory } from "../../../../../common/hooks/console/management/goods/usePostGoodsCategory";
import { useGetGoodsCategoryInfo } from "../../../../../common/hooks/console/management/goods/useGetGoodsCategoryInfo";
import { api_uri } from "../../../../../common/hooks/utils/enum";
import { usePutGoodsCategoryInfo } from "../../../../../common/hooks/console/management/goods/usePutGoodsCategoryInfo";
import { useDeleteGoodsCategory } from "../../../../../common/hooks/console/management/goods/useDeleteGoodsCategory";
import { fetchGoodsOrderCount, GoodsOrderCount } from "../../../../../common/hooks/console/management/goods/useGetGoodsOrderCount";
import { usePutGoodsRestore } from "../../../../../common/hooks/console/management/goods/usePutGoodsRestore";
import { useAuthStore } from "../../../../store/useAuthStore";

const Goods = () => {
    const { addToast } = useToastStore();
    const { showPop } = useSystemPopStore();
    const level = useAuthStore(state => state.m_level);
    const accessToken = useAuthStore(state => state.accessToken);

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [search, setSearch] = useState<string>("category_name");
    const [searchTxt, setSearchTxt] = useState<string>("");
    const [field, setField] = useState<string>("");
    const [sortDirection, setSortDirection] = useState<string>("ASC");
    const [newGoods, setNewGoods] = useState<boolean>(false);
    const [selectedIdx, setSelectedIdx] = useState<number | null>(null);
    /* 켜면 삭제된 상품만 본다. 주문판매의 '삭제건만 보기' 와 같은 쓰임이다. */
    const [showDeleted, setShowDeleted] = useState<boolean>(false);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [categoryPop, setCategoryPop] = useState<boolean>(false);
    const [categoryManagerPop, setCategoryManagerPop] = useState<boolean>(false);
    const [selectedCategory, setSelectedCategory] = useState<string>("");
    const [addCategory, setAddCategory] = useState<boolean>(false);
    const [categoryMode, setCategoryMode] = useState<"add" | "edit">("add");
    const [selectedCategoryIdx, setSelectedCategoryIdx] = useState<number | null>(null);
    const [imageFile, setImageFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const [categoryName, setCategoryName] = useState<string>("");
    const [wreathOption, setWreathOption] = useState<boolean>(false);
    const [unionOption, setUnionOption] = useState<boolean>(false);
    const [categoryError, setCategoryError] = useState<boolean>(false);

    const { data: listData } = useGetGoods(currentPage, 20, search, searchTxt, field, sortDirection, showDeleted);
    const { data: categoryData } = useGetGoodsCategory();
    const deleteGoodsMutation = useDeleteGoods();
    const putGoodsCategoryMutation = usePutGoodsCategory();
    const { mutate: postCategory } = usePostGoodsCategory();
    const { data: categoryInfoData } = useGetGoodsCategoryInfo(selectedCategoryIdx || 0);
    const { mutate: putCategory } = usePutGoodsCategoryInfo();
    const { mutate: deleteCategory } = useDeleteGoodsCategory();

    const categoryOptions = categoryData
        ? categoryData.map(cat => ({
              value: cat.product_category_idx.toString(),
              label: cat.category_name,
          }))
        : [];

    const handleDeleteCategory = (categoryIdx: number) => {
        showPop({
            title: "카테고리를 삭제하시겠습니까?",
            content: "카테고리 삭제시 카테고리에 등록돼 있는 <br /> 상품이 모두 삭제됩니다.",
            rightButton: "확인",
            type: "negative",
            onRightClick: () => {
                addToast({
                    type: "delete",
                    onConfirmDelete: () => {
                        deleteCategory(categoryIdx, {
                            onSuccess: () => {
                                if (categoryIdx === selectedCategoryIdx) {
                                    setAddCategory(false);
                                }
                            },
                        });
                    },
                });
            },
        });
    };

    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            setImageFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleRemoveImage = () => {
        setImageFile(null);
        setPreview(null);
    };

    const handleCategoryClick = (categoryIdx: number) => {
        setAddCategory(true);
        setCategoryMode("edit");
        setSelectedCategoryIdx(categoryIdx);
    };
    const handleAddCategoryClick = () => {
        setCategoryName("");
        setImageFile(null);
        setUnionOption(false);
        setWreathOption(false);
        setAddCategory(true);
        setCategoryMode("add");
        setSelectedCategoryIdx(null);
        setPreview(null);
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleSortChange = (newField: string) => {
        setField(prevField => {
            if (prevField !== newField) {
                const initialDirection = newField === "product_category" || newField === "product_name" ? "ASC" : "DESC";
                setSortDirection(initialDirection);
                return newField;
            }
            setSortDirection(prev => (prev === "ASC" ? "DESC" : "ASC"));
            return newField;
        });
    };

    const handleRowClick = (idx: number) => {
        setSelectedIdx(idx);
        setNewGoods(false);
    };

    const restoreGoodsMutation = usePutGoodsRestore();

    /*
    // 삭제한 상품 되살리기. 상품번호가 그대로 살아나므로 그 상품으로 나간 과거 주문의
    // 상품코드 표기도 함께 돌아온다.
    */
    const handleRestore = (restoreIdx?: number) => {
        const targets = restoreIdx ? Array.from(new Set([...selectedIds, restoreIdx])) : selectedIds;

        /* 고른 게 없으면 확인창도 띄우지 않는다 */
        if (targets.length === 0) return;

        showPop({
            title: "선택한 상품을 복구하시겠습니까?",
            content: "삭제 전 상태로 되돌아가며, 해당 상품으로 접수된<br />과거 주문의 상품코드도 함께 복구됩니다.",
            rightButton: "확인",
            onRightClick: () => {
                restoreGoodsMutation.mutate(
                    { product_idx: targets },
                    {
                        onSuccess: () => {
                            setSelectedIdx(null);
                            setSelectedIds([]);
                        },
                    },
                );
            },
        });
    };

    const handleDelete = async (deleteIdx?: number) => {
        const updatedSelectedRows = deleteIdx ? Array.from(new Set([...selectedIds, deleteIdx])) : selectedIds;

        /* 고른 게 없으면 확인창도 띄우지 않는다 */
        if (updatedSelectedRows.length === 0) return;

        /*
        // 주문이 걸린 상품을 지우면 그 주문들의 상품코드까지 같이 사라진다. 상품 목록만 보고는
        // 알 수 없는 영향이라 삭제 전에 건수를 알린다.
        // 조회가 실패해도 삭제 자체는 막지 않는다. (경고가 없을 뿐 기존 동작 그대로)
        */
        const orderCounts: GoodsOrderCount[] = await fetchGoodsOrderCount(accessToken, updatedSelectedRows).catch(
            () => [] as GoodsOrderCount[],
        );
        const totalOrderCount = orderCounts.reduce((sum, item) => sum + item.order_count, 0);

        showPop({
            title: "해당 내역을 삭제하시겠습니까",
            content:
                totalOrderCount > 0
                    ? `선택한 상품으로 접수된 주문이 ${totalOrderCount.toLocaleString("ko-KR")}건 있습니다.<br />삭제하면 해당 주문의 상품코드도 함께 사라집니다.`
                    : undefined,
            rightButton: "확인",
            type: "negative",
            onRightClick: () => {
                addToast({
                    type: "delete",
                    onConfirmDelete: () => {
                        deleteGoodsMutation.mutate(
                            { product_idx: updatedSelectedRows },
                            {
                                onSuccess: () => {
                                    setSelectedIdx(prevIdx => {
                                        if (prevIdx === null) {
                                            return prevIdx;
                                        }

                                        const remainingItems =
                                            listData?.data_list?.filter(item => !updatedSelectedRows.includes(item.product_idx)) ?? [];

                                        const newIdx = updatedSelectedRows.includes(prevIdx)
                                            ? (remainingItems[0].product_idx ?? null)
                                            : prevIdx;

                                        return newIdx;
                                    });
                                },
                            },
                        );
                    },
                });
            },
        });
    };

    const handleMoveCategory = () => {
        let hasError = false;
        if (!selectedCategory) {
            setCategoryError(true);
            hasError = true;
        }
        if (hasError) return;
        putGoodsCategoryMutation.mutate(
            {
                product_idx: selectedIds,
                product_category_idx: parseInt(selectedCategory),
            },
            {
                onSuccess: () => {
                    setCategoryPop(false);
                    setSelectedCategory("");
                    setSelectedIds([]);
                    addToast({ type: "success", message: "카테고리 이동이 완료되었습니다." });
                },
            },
        );
    };

    const handleSubmitCategory = () => {
        postCategory({
            category_name: categoryName,
            wreath_option: wreathOption,
            union_option: unionOption,
            category_image: imageFile,
        });
        setCategoryName("");
        setImageFile(null);
        setPreview("");
        setUnionOption(false);
        setWreathOption(false);
    };

    const handleModifyCategory = () => {
        putCategory({
            categoryIdx: selectedCategoryIdx,
            category_name: categoryName,
            wreath_option: wreathOption,
            union_option: unionOption,
            category_image: imageFile,
            del_image: !(preview || imageFile),
        });
    };

    const handleWreathOptionChange = () => {
        setWreathOption(prev => {
            if (prev) {
                setUnionOption(false);
            }
            return !prev;
        });
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTxt]);

    useEffect(() => {
        setCategoryName(categoryInfoData?.category_name || "");
        setUnionOption(categoryInfoData?.union_option || false);
        setWreathOption(categoryInfoData?.wreath_option || false);
        if (categoryInfoData?.category_image) {
            setPreview(`${api_uri}/${categoryInfoData?.category_image}`);
        } else {
            setPreview(null);
        }
    }, [categoryInfoData]);

    return (
        <div className="flex overflow-hidden h-dvh">
            <div className="flex flex-col w-full">
                <SettingHeader totalPage={listData?.last_page} currentPage={currentPage} onPageChange={handlePageChange} />
                <div className="flex-1 flex flex-col overflow-hidden">
                    <div className="flex justify-between px-3 py-3.5 items-center border-b border-gray4">
                        <div className="flex gap-2 items-center ">
                            <div className="flex gap-1 items-center">
                                <p className="text-xs">총</p>
                                <button className="text-sm font-bold text-primary2">{listData?.total_count.toLocaleString()}</button>
                            </div>
                            <div className="flex gap-1 items-center">
                                <p className="text-xs">선택</p>
                                <button className="text-sm font-bold text-primary2">{selectedIds.length}</button>
                            </div>
                            {/*
                            // 삭제건 보기에서는 카테고리 관리·이동을 감춘다.
                            // 이동은 서버가 is_delete='N' 만 받아 404 가 나고, 관리는 되긴 하지만
                            // 지운 상품을 보러 온 자리에 있을 기능이 아니다.
                            */}
                            {level !== 7 && !showDeleted && (
                                <>
                                    <div className="flex relative">
                                        <Button
                                            size="S"
                                            className="px-2"
                                            onClick={() => {
                                                setCategoryPop(false);
                                                setCategoryManagerPop(true);
                                            }}
                                        >
                                            카테고리 관리
                                        </Button>
                                        {categoryManagerPop && (
                                            <div className="absolute bg-white translate-y-10 w-[800px] h-[488px] shadow-custom rounded-2xl">
                                                <div className="flex px-6 py-5 justify-between items-center">
                                                    <p className="text-2xl font-bold ">카테고리 관리</p>
                                                    <CloseIcon
                                                        onClick={() => {
                                                            setAddCategory(false);
                                                            setCategoryManagerPop(false);
                                                            setSelectedCategoryIdx(null);
                                                        }}
                                                        className="cursor-pointer"
                                                    />
                                                </div>
                                                <div className="px-6 flex gap-2 h-[392px]">
                                                    <div className="flex flex-col gap-1 min-w-80 h-full">
                                                        <Button size="M" onClick={handleAddCategoryClick}>
                                                            카테고리 추가
                                                        </Button>
                                                        <div className="flex flex-col border border-gray4 rounded-lg h-full overflow-y-auto">
                                                            {categoryData &&
                                                                categoryData.length > 0 &&
                                                                categoryData.map(category => (
                                                                    <div
                                                                        key={category.product_category_idx}
                                                                        className={`${selectedCategoryIdx === category.product_category_idx && "bg-primary4"} flex hover:bg-primary4 items-center gap-1 px-3 py-2 border-b border-gray4 cursor-pointer`}
                                                                        onClick={() => handleCategoryClick(category.product_category_idx)}
                                                                    >
                                                                        <p className="text-sm font-bold text-gray2 truncate">
                                                                            {category.category_name}
                                                                        </p>
                                                                        {category.wreath_option && (
                                                                            <p className="text-xs text-gray2 whitespace-nowrap">화환</p>
                                                                        )}
                                                                        {category.union_option && (
                                                                            <p className="text-xs text-gray2 whitespace-nowrap">노조</p>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </div>
                                                    {addCategory ? (
                                                        <div className="flex w-full flex-col gap-4">
                                                            <div className="flex justify-between items-center">
                                                                <p className="text-xl font-bold text-gray2">
                                                                    {categoryMode === "add" ? "카테고리 추가" : "카테고리 수정"}
                                                                </p>
                                                                {categoryMode === "add" ||
                                                                    (level !== 8 && (
                                                                        <Button
                                                                            size="S"
                                                                            className="px-2"
                                                                            status="error"
                                                                            onClick={() => handleDeleteCategory(selectedCategoryIdx || 0)}
                                                                        >
                                                                            삭제
                                                                        </Button>
                                                                    ))}
                                                            </div>

                                                            <div className="flex flex-col gap-2">
                                                                <Input
                                                                    maxLength={30}
                                                                    placeholder="30자"
                                                                    value={categoryName}
                                                                    onChange={e => setCategoryName(e.target.value)}
                                                                />
                                                                <div className="flex flex-col gap-2">
                                                                    <p className="text-sm text-gray2">카테고리 대표 이미지</p>
                                                                    {preview ? (
                                                                        <div className="relative w-[60px] h-[60px] rounded-xl border overflow-hidden">
                                                                            <img
                                                                                src={preview}
                                                                                alt="미리보기"
                                                                                className="w-full h-full rounded-xl object-contain"
                                                                            />
                                                                            <button
                                                                                className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                                                onClick={handleRemoveImage}
                                                                            >
                                                                                <CloseWhiteIcon />
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <label className="w-[60px] h-[60px] flex items-center justify-center rounded-xl border cursor-pointer">
                                                                            <PlusIcon className="w-7 h-7" />
                                                                            <input
                                                                                type="file"
                                                                                accept="image/*"
                                                                                className="hidden"
                                                                                onChange={handleImageUpload}
                                                                            />
                                                                        </label>
                                                                    )}
                                                                </div>
                                                                <div className="text-gray2 flex flex-col gap-2">
                                                                    <p className="text-sm">입력폼 유형 옵션</p>
                                                                    <div className="flex items-center gap-1">
                                                                        <CheckBox
                                                                            checked={wreathOption}
                                                                            onChange={handleWreathOptionChange}
                                                                        />
                                                                        <div>
                                                                            <p className="font-bold text-sm">
                                                                                체크시, '화환' 입력폼 노출 설정
                                                                            </p>
                                                                            <p className="text-xs">
                                                                                (해당 카테고리의 상품 선택시, 고객 관리에 활성화된 입력폼이
                                                                                노출됩니다.)
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="text-gray2 flex flex-col gap-2">
                                                                    <p className="text-sm">
                                                                        노조 가입 필수 옵션 (입력폼 유형 옵션 체크시 가능합니다.)
                                                                    </p>
                                                                    <div className="flex items-center gap-1">
                                                                        <CheckBox
                                                                            checked={unionOption}
                                                                            onChange={() => wreathOption && setUnionOption(prev => !prev)}
                                                                        />
                                                                        <div>
                                                                            <p className="font-bold text-sm">
                                                                                체크시, 노조가입 여부 ‘가입’ 필수 설정
                                                                            </p>
                                                                            <p className="text-xs">
                                                                                (해당 카테고리의 상품 선택 시, 노조가입 여부가 ‘가입'으로
                                                                                필수 선택됩니다.)
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="flex w-full gap-2">
                                                                <Button className="w-full" size="L" onClick={() => setAddCategory(false)}>
                                                                    취소
                                                                </Button>
                                                                <Button
                                                                    status="regist"
                                                                    className="w-full"
                                                                    size="L"
                                                                    onClick={() => {
                                                                        categoryMode === "add"
                                                                            ? handleSubmitCategory()
                                                                            : handleModifyCategory();
                                                                    }}
                                                                >
                                                                    저장
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="flex flex-col items-center justify-center gap-5 h-full w-full">
                                                            <Empty />
                                                            <p className="text-grayicon text-lg text-center font-bold">
                                                                카테고리를 추가하거나
                                                                <br />
                                                                선택해주세요.
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex relative">
                                        <Button
                                            size="S"
                                            className="px-2 disabled:opacity-40 disabled:cursor-default"
                                            disabled={selectedIds.length === 0}
                                            onClick={() => {
                                                setCategoryManagerPop(false);
                                                setCategoryPop(true);
                                            }}
                                        >
                                            카테고리 이동
                                        </Button>
                                        {categoryPop && (
                                            <div className="absolute bg-white translate-y-10 w-[480px] shadow-custom rounded-2xl">
                                                <div className="flex px-6 py-5 justify-between items-center">
                                                    <p className="text-2xl font-bold ">카테고리 이동</p>
                                                    <CloseIcon
                                                        onClick={() => {
                                                            setCategoryPop(false);
                                                            setSelectedCategory("");
                                                            setCategoryError(false);
                                                        }}
                                                        className="cursor-pointer"
                                                    />
                                                </div>
                                                <div className="flex flex-col px-6 pb-5 gap-4">
                                                    <div className="flex text-xl font-bold">
                                                        <p>선택한 내역</p>
                                                        <p className="text-error pl-1.5">{selectedIds.length}</p>
                                                        <p>개를 이동합니다.</p>
                                                    </div>
                                                    <div className="flex gap-2 w-full">
                                                        <SelectBox
                                                            height="max-h-[400px]"
                                                            status={categoryError ? "error" : ""}
                                                            className="w-full"
                                                            placeholder="이동할 카테고리를 선택해주세요."
                                                            options={categoryOptions}
                                                            value={selectedCategory}
                                                            onChange={value => {
                                                                setCategoryError(false);
                                                                setSelectedCategory(value);
                                                            }}
                                                        />
                                                        <Button onClick={handleMoveCategory} className="w-20" size="S" status="regist">
                                                            이동
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                            {level !== 7 && level !== 8 && !showDeleted && (
                                <Button
                                    disabled={selectedIds.length === 0}
                                    onClick={() => handleDelete(selectedIdx || undefined)}
                                    size="S"
                                    className="px-2 disabled:opacity-40 disabled:cursor-default"
                                    status="error"
                                >
                                    삭제
                                </Button>
                            )}
                            {level !== 7 && level !== 8 && showDeleted && (
                                <Button
                                    disabled={selectedIds.length === 0}
                                    onClick={() => handleRestore(selectedIdx || undefined)}
                                    size="S"
                                    className="px-2 disabled:opacity-40 disabled:cursor-default"
                                    status="regist"
                                >
                                    복구
                                </Button>
                            )}
                            {/*
                            // 삭제건 보기. 삭제된 상품은 목록에서 빠지므로 이 토글이 없으면
                            // 지운 상품의 이력을 보거나 되살릴 길이 없다.
                            */}
                            <button
                                type="button"
                                onClick={() => {
                                    setShowDeleted(prev => !prev);
                                    setSelectedIds([]);
                                    setSelectedIdx(null);
                                    setNewGoods(false);
                                    setCurrentPage(1);
                                }}
                                className={`text-sm underline whitespace-nowrap ${showDeleted ? "font-bold text-[#00489D]" : "text-gray2"}`}
                            >
                                {showDeleted ? "전체보기" : "삭제건 보기"}
                            </button>
                        </div>
                        <div className="flex gap-2 items-center">
                            {/* 삭제건 보기에서는 등록 버튼을 감춘다. 지운 상품을 보러 온 자리다. */}
                            {level !== 7 && !showDeleted && (
                                <Button onClick={() => setNewGoods(true)} size="S" className="px-2" status="regist">
                                    상품 등록
                                </Button>
                            )}
                            <div className="w-[240px] flex gap-1">
                                <SelectBox
                                    status="none"
                                    className="min-w-[120px]"
                                    options={[
                                        { value: "category_name", label: "카테고리명" },
                                        { value: "product_name", label: "상품명" },
                                    ]}
                                    value={search}
                                    onChange={(value: string) => setSearch(value)}
                                />
                                <Input
                                    placeholder="검색"
                                    status="none"
                                    className=""
                                    value={searchTxt}
                                    onChange={e => setSearchTxt(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex-1 overflow-y-auto">
                        <GoodsTable
                            isNewGoods={newGoods}
                            showDeleted={showDeleted}
                            data={listData?.data_list}
                            idx={selectedIdx || 0}
                            onSortChange={handleSortChange}
                            onRowClick={handleRowClick}
                            onSelectionChange={selectedIds => setSelectedIds(selectedIds)}
                        />
                    </div>
                </div>
            </div>

            <div className="md:min-w-[620px] min-w-[560px] h-dvh overflow-y-auto flex flex-col">
                {/*
                // 삭제건 보기에서는 등록 폼을 띄우지 않는다. 지운 상품을 보러 들어온 자리에
                // 신규 등록 화면이 뜨면 이번처럼 기존 상품을 고쳐 쓰는 실수를 부른다.
                */}
                {listData === undefined ? null : showDeleted && listData?.total_count === 0 ? (
                    <div className="flex h-full items-center justify-center">
                        <p className="text-gray3">삭제된 상품이 없습니다.</p>
                    </div>
                ) : !showDeleted && (listData?.total_count === 0 || newGoods) ? (
                    <NewGoods
                        onProductCreated={productIdx => {
                            setSelectedIdx(productIdx);
                            setNewGoods(false);
                        }}
                    />
                ) : (
                    /* 고른 상품이 없으면 빈 수정 폼을 그대로 보여준다. 빈 상태에서 삭제를 눌러도 handleDelete 가 막는다. */
                    <ModifyGoods key={selectedIdx} productIdx={selectedIdx || 0} onDelete={idx => handleDelete(idx)} />
                )}
            </div>
        </div>
    );
};

export default Goods;
